<template>
  <div class="v-select-radio">
   <v-treeview
     :active.sync="active"
     :items="item"
     @update:active='updateValue'
     open-all
     dense
     activatable
     v-bind='$attrs'
   >
   <template v-slot:label="{ item }">
      <span>{{item.name}}</span>
    </template>
   <template v-slot:prepend="{ item, open }" v-if="icon">
       <v-icon v-if="!item.file">
         {{ open ? openIcon : closeIcon }}
       </v-icon>
       <v-icon v-else>
         {{ files[item.file] }}
       </v-icon>
     </template>
   </v-treeview>
  </div>
</template>

<script>
import { tree } from '@/api/data.js'

export default {
  name: 'v-select_tree',
  data () {
    return {
      item: [],
      active: []
    }
  },
  props: {
    path: {
      type: String,
      required: true
    },
    icon: {
      type: Boolean,
      default: false
    },
    openIcon: {
      type: String,
      default: 'mdi-folder-open'
    },
    closeIcon: {
      type: String,
      default: 'mdi-folder'
    }
  },
  watch: {
    active (val) {
      this.$emit('on-change', val)
    }
  },
  methods: {
    loadData () {
      tree(this.path).then(res => {
        if (res.status === 200) {
          this.item = res.data
        }
      })
    },
    updateValue (value) {
      this.$emit('input', value)
    }
  },
  created() {
    this.loadData()
  }
}
</script>

<style lang="sass" scope>
  $color:  #676767
  $error_color: #ff5252
  .v-select-radio
    .v-treeview
      .v-treeview-node__root
        min-height: 30px
      .v-treeview-node__content
        cursor: pointer
    .v-treeview-node__root
      padding-left: 0px
</style>
